require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



// WEBPACK FOOTER //
// ./node_modules/core-js/library/fn/object/assign.js